import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import DateRangePickerProps from './DateRangePickerProps'

import Messages from './Messages'
import Month from './Month'
import Range from './Range'

export default {
    props: DateRangePickerProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent, 
        Messages, 
        Month, 
        Range
    ],
   
    mounted() {
        kendo.jQuery(this.$el).kendoDateRangePicker(this.widgetOptions)

        if(this.v3) {
            this.ready()
        }

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateRangePicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/KendoDateRangePickerMixin.js